var map = {
	"./php_de.json": [
		9664,
		664
	],
	"./php_en.json": [
		5470,
		470
	],
	"./php_es.json": [
		1877,
		877
	],
	"./php_fr.json": [
		5818,
		818
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5595;
module.exports = webpackAsyncContext;